// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3vbLS","content":"styles_content__3XCBP","tableWrap":"styles_tableWrap__2N45P"};